import { render, staticRenderFns } from "./interviewGeneralInformation.vue?vue&type=template&id=08d36e01"
import script from "./interviewGeneralInformation.vue?vue&type=script&lang=js"
export * from "./interviewGeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./interviewGeneralInformation.vue?vue&type=style&index=0&id=08d36e01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports